// Exporting this from here allows easier window mocking in tests
export default window;
